import styled from 'styled-components';
import screens from "../../../themes/screens";

const Wrap = styled.section`
    display: flex;
    justify-content: space-between;
    margin: ${({ theme }) => theme.spacers.XL} 5% ${({ theme }) => theme.spacers.XL};
    padding: ${({ theme }) => theme.spacers.XL};

    ${({ theme }) => theme.superQuery.all.and.maxWidth.tabletMax.css`
        flex-direction: column;
        padding: 0;
        margin-top: ${theme.spacers.XXL};
        margin-bottom: ${theme.spacers.XXL};
        align-items: center;
    `}
`;

const Item = styled.section`
    display: flex;
    max-width: 32%;

    ${({ theme }) => theme.superQuery.all.and.maxWidth.tabletMax.css`
        max-width: 490px;
    `}

    ${({ theme }) => theme.superQuery.all.and.maxWidth.mobileMax.css`
        max-width: 360px;
        margin-bottom: ${theme.spacers.XXL};
        :last-child {
            margin-bottom: 0;
        }
    `}

    img {
        width: 80px;
        align-self: center;

        ${({ theme }) => theme.superQuery.all.and.maxWidth.mobileMax.css`
            align-self: flex-start;
        `};
    }
`;

const TextWrapper = styled.section`
    display: flex;
    flex-direction: column;
    margin-left: ${({ theme }) => theme.spacers.XL};
    margin-right: ${({ theme }) => theme.spacers.L};
    padding: ${({ theme }) => theme.spacers.L} 0;
    font-size: 16px;

    ${({ theme }) => theme.superQuery.all.and.maxWidth.mobileMax.css`
        align-items: flex-start;
        padding: 0;
        margin-left: ${theme.spacers.L};
        line-height: 24px;
        text-align: left;
    `};
`;

const Text = styled.section`
    span {
        font-size: 16px;
        line-height: 24px;
        color: ${({ theme }) => theme.colors['Level 5']};
    }
`;

const SectionTitle = styled.h2`
    span {
        ${({ theme }) => theme.typography.Paragraph}
        color: ${({ theme }) => theme.colors.Foreground};
        font-size: 24px;
        font-weight: 800;
        margin: 0 0 ${({ theme }) => theme.spacers.M} 0;

        ${({ theme }) => theme.superQuery.minWidth.mobileMin.and.maxWidth.tabletMax.css`
            font-size: 20px;
            line-height: 24px;
        `}
    }
`;

export { Wrap, Item, TextWrapper, SectionTitle, Text };
